import axios from '@/utils/axios'
export function createAirticket (data) {
  return axios({
    url: '/airtickets',
    method: 'post',
    data
  })
}

export function getExchangeRate (data = { base: 'USD' }) {
  return axios({
    url: '/currency',
    method: 'post',
    data
  })
}

export function getSelectAirticket (id) {
  return axios({
    url: '/airtickets/' + id,
    method: 'get'
  })
}

export function deleteAirticket (airtickets, username) {
  return axios({
    url: '/airtickets',
    method: 'delete',
    data: { transaction_id_list: airtickets }
  })
}

export function createTransactionGroup (data) {
  return axios({
    url: '/transaction_group',
    method: 'post',
    data: {
      transaction_id_list: data.transaction_id_list,
      create_by: data.create_by
    }
  })
}

export function addTransactionToGroup (data) {
  return axios({
    url: '/transaction_group/update',
    method: 'post',
    data: {
      transaction_id_list: data.transaction_id_list,
      transaction_group_id: data.transaction_group_id
    }
  })
}

export function fetchGroupList (data) {
  return axios({
    url: '/transaction_group/list',
    method: 'post',
    data: {
      create_by: data.create_by
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/airticket.js